import type { GetForestOwnerGroupsResponse } from '@/types/ReferenceData/ForestOwnerGroup.ts'
import { apiGet } from '../ApiClient'

export async function getForestOwnerGroups(): Promise<GetForestOwnerGroupsResponse> {
  return apiGet<GetForestOwnerGroupsResponse>('/forestowner-groups')
}
